export class Singleton {
    id: number;
    singletonClassId: number;
    value: string;
    format: string;
    refName: string;
    fieldNo: number;
}
